<template>
  <div
    class="relative"
    :class="[
      { graph: item.type === 'PORTFOLIO' },
      { arrows: item.type !== 'PORTFOLIO' && item.strategy_symbol === 'ANY' },
    ]"
  >
    <div class="relative flex h-full flex-col justify-between">
      <div class="h-full space-y-6 px-4 py-4">
        <div class="flex h-full flex-col space-y-6">
          <div class="relative flex justify-between">
            <div class="flex flex-col">
              <div class="flex items-center">
                <!-- v-if="!item.masks_list.includes('FIRST_PLAY')" -->
                <status-indicator-component
                  :status="item.status"
                  :position="
                    item.type !== 'PORTFOLIO'
                      ? item.position_status
                      : portfolioPosition
                  "
                  :error="toggle_disabled"
                />
                <!-- <div class="h-3.5 w-3.5"></div> -->
                <p
                  class="text-ontick-steel-400 ml-2 text-xs uppercase dark:text-gray-400"
                >
                  {{ symbolLabel }}
                </p>
              </div>
              <div class="flex items-center space-x-1">
                <img
                  v-if="item.partner_badge"
                  :src="item.partner_badge"
                  class="h-4 w-4"
                />
                <p
                  :content="item.strategy_name"
                  v-tippy="{ arrow: true, theme: 'green' }"
                  class="text-ontick-carbon-500 xs:w-full w-36 truncate text-lg font-semibold dark:text-gray-300 lg:!w-32 2xl:!w-full"
                >
                  {{ item.strategy_name }}
                </p>
              </div>
              <span
                class="text-[10px] font-medium text-gray-500 dark:text-gray-400"
              >
                ID: {{ item.investment_id }}
              </span>
            </div>
            <div
              class="absolute top-2 -right-3 flex flex-none items-center"
              :id="`toggle_button${_uid}`"
            >
              <ontick-toggle
                v-show="item.status != 'HIDDEN'"
                class=""
                :class="
                  toggle_disabled ? 'cursor-not-allowed' : 'cursor-pointer'
                "
                :active="item.status == 'RUNNING' ? true : false"
                @switch="
                  $emit('toggleSwitch', {
                    investmentId: item.investment_id,
                    investmentStatus: item.status,
                    toogle: (toggle_disabled =
                      item.status === 'RUNNING' ? false : toggle_disabled),
                  }),
                    selectedParams({ value: typed_volume, item: item })
                "
              />
              <ontick-form-dropdown
                content="Outras opções"
                v-tippy="{ arrow: true, theme: 'green' }"
                :position="dropdownPosition"
                :optionCard="true"
                :disabledOptionDefault="true"
                :optionInitial="optionDefault"
                :options="optionsSelect"
                @optionSelected="optionSelected($event, item)"
              ></ontick-form-dropdown>
            </div>
          </div>

          <!-- MULTI-SYMBOL -->
          <multi-symbol-pnl-component
            :item="item"
            v-if="
              (item.type === 'PORTFOLIO' || item.strategy_symbol === 'ANY') &&
              item.status === 'RUNNING'
            "
          />

          <div
            :class="item.status === 'RUNNING' ? 'space-y-6' : 'space-y-0'"
            class="h-full"
            v-else
          >
            <card-pnl
              v-if="getVisualizationMode === 'card'"
              :item="item"
              :minimize="getVisualizationMode === 'mini-card'"
            />
            <card-pnl-minimize v-else :item="item" />
            <collapse-transition>
              <template v-if="getVisualizationMode === 'card'">
                <card-strategy-running
                  :item="item"
                  v-if="item.status === 'RUNNING'"
                />
              </template>
            </collapse-transition>
            <card-edit
              v-if="item.status === 'STOPPED' || item.status == 'HIDDEN'"
              :item="item"
              @statusValidate="validate"
              @seletedParam="
                setInvestmentVolume({
                  investment_id: item.investment_id,
                  volume: $event,
                })
              "
              :disabled="!setVolume"
            />
          </div>
        </div>
      </div>
      <card-status :item="item" v-if="!isMultiSymbol" />
    </div>
    <transition-group name="mask">
      <template v-if="item.masks_list">
        <div
          v-for="(mask, index) in item.masks_list"
          :key="index + _uid"
          class=""
        >
          <card-mask
            v-if="item.masks_list.length > 0"
            :mask="mask"
            @close="closeMask(item.investment_id, mask)"
          />
        </div>
      </template>
    </transition-group>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import * as icons from "@/app/assets/icons/investments";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import { ObserveVisibility } from "vue-observe-visibility";
import event_bus from "../../../../../../shared/utils/event_bus";

export default {
  directives: {
    "observe-visibility": ObserveVisibility,
  },
  components: {
    CollapseTransition,
    CardStrategyRunning: () => import("./card-strategy-running.component.vue"),
    StatusIndicatorComponent: () => import("../status-indicator.component.vue"),
    OntickToggle: () =>
      import("../../../ontick-toggle/ontick-toggle.component.vue"),
    CardEdit: () => import("./card-edit/card-edit.component.vue"),
    CardStatus: () => import("./card-strategy-status.component.vue"),
    CardPnl: () => import("./card-strategy-pnl.component.vue"),
    CardPnlMinimize: () => import("./card-strategy-pnl-minimize.component.vue"),
    CardMask: () => import("../card-mask/card-mask.component.vue"),
    MultiSymbolPnlComponent: () =>
      import("../card-portfolio/multi-symbol-pnl.component.vue"),
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    dropdownPosition: {
      type: String,
      default: "right",
      validator: (val) => {
        return ["right", "left", "fixed"].includes(val);
      },
    },
    setVolume: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      toggle_disabled: true,
      typed_volume: this.item.min_volume,

      optionDefault: {
        icon: icons.details,
        label: null,
      },
      optionsSelect: [
        { icon: icons.editParams, label: "Parâmetros" },
        { icon: icons.performance, label: "Histórico" },
        {
          icon: icons.removeInvestment,
          label: this.item.status != "HIDDEN" ? "Arquivar" : "Desarquivar",
        },
      ],

      defaultSweetAlert: {
        title: "",
        icon: "success",
        toast: false,
        position: "center",
        timer: 4000,
        timerProgressBar: true,
        customClass: {
          popup: "sweetalert_popup",
          title: "sweetalert_title",
          confirmButton:
            "bg-ontick-blue-600 text-gray-300 px-6 py-2 rounded-md text-lg",
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      getVisualizationMode: "investment/getVisualizationMode",
      getUiTheme: "config/getUiTheme",
      getSelectedAccount: "accountTypes/getSelectedAccount",
    }),
    symbolLabel() {
      if (this.item.type === "PORTFOLIO") {
        return "Portfólio";
      } else if (this.item.strategy_symbol === "ANY") {
        return "Multiativos";
      } else {
        return this.item.strategy_symbol;
      }
    },
    isMultiSymbol() {
      return (
        this.item.strategy_symbol === "ANY" ||
        Array.isArray(this.item.strategy_symbol)
      );
    },
    activitySign() {
      return {
        "bg-ontick-green-500": this.item.status === "RUNNING",
        "bg-ontick-steel-600": this.item.status === "STOPPED",
      };
    },
    portfolioPosition() {
      let investment = this.item;
      if (
        investment.sub_strategies?.every((item) => {
          return item.position_status === "Zerado";
        })
      ) {
        return "Zerado";
      }
      return "Posicionado";
    },
    portfolioCurrentExposure() {
      return this.item.sub_strategies?.reduce((acc, item) => {
        return acc + (item.position_volume || 0);
      }, 0);
    },
    // portfolioOpenPnl() {
    //   return this.item.sub_strategies.reduce((acc, item) => {
    //     return acc + (item.open_pnl || 0);
    //   }, 0);
    // },
    // portfolioClosedPnl() {
    //   return this.item.sub_strategies.reduce((acc, curr) => {
    //     return acc + (curr.closed_pnl || 0);
    //   }, 0);
    // },
    portfolioCardSymbols() {
      let strategies = this.item.sub_strategies;
      let symbols = Array(
        ...new Set(strategies.map((sub) => sub.strategy_symbol))
      );
      let positionsBySymbol = symbols.map((symbol) => {
        return {
          name: symbol,
          buy_volume: strategies
            .filter(
              (strategy) =>
                strategy.strategy_symbol === symbol &&
                ["Comprado", "BUY"].includes(strategy.position_status)
            )
            .reduce((acc, curr) => acc + (curr.position_volume || 0), 0),
          sell_volume: strategies
            .filter(
              (strategy) =>
                strategy.strategy_symbol === symbol &&
                ["Vendido", "SELL"].includes(strategy.position_status)
            )
            .reduce((acc, curr) => acc + (curr.position_volume || 0), 0),
        };
      });
      return positionsBySymbol;
    },
  },

  methods: {
    ...mapActions({
      selectedParams: "investment/selectedParams",
      getInvestments: "investment/getInvestments",
      removeMask: "investment/removeMask",
      setInvestmentVolume: "investment/setInvestmentVolume",
    }),

    closeMask(investment_id, mask) {
      this.removeMask({
        investment_id,
        mask,
      });
      if (mask.fixedMask) {
        this.$api
          .post(this.$endpoint.DISMISS_MASK, {
            investment_id: investment_id,
            notification_type: mask.type,
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },

    optionSelected(event, investment) {
      if (event.label == "Parâmetros") {
        // editar parâmetro
        this.$router.push({
          path: "/investments/" + Number(investment.investment_id) + "/edit",
        });
      }
      if (event.label == "Histórico") {
        this.$router.push({
          name: "Histórico",
          params: {
            id: Number(investment.investment_id),
            label: investment.strategy_name,
          },
        });
      }
      if (event.label == "Arquivar") {
        if (investment.status == "STOPPED") {
          this.$api
            .post(this.$endpoint.INVESTMENT_HIDE, {
              investment_id: Number(investment.investment_id),
            })
            .then((response) => {
              this.$swal({
                icon: "success",
                iconHtml: this.$icons.swal_success,
                title: response.data.msg,
              });
              this.getInvestments();

              // this.$emit("reload", { investmentActiveOrHidden: "ACTIVE" });
            });
        } else if (investment.status == "RUNNING") {
          this.$swal({
            title: "Você deve parar o investimento para ocultá-lo",
            icon: "error",
            timer: 8000,
          });
        }
      }
      if (event.label == "Desarquivar") {
        if (investment.status == "HIDDEN") {
          this.$api
            .post(this.$endpoint.INVESTMENT_SHOW, {
              investment_id: Number(investment.investment_id),
            })
            .then((response) => {
              this.$swal({
                icon: "success",
                iconHtml: this.$icons.swal_success,
                title: response.data.msg,
              });
              event_bus.$emit("RELOAD_HIDDEN");
              this.getInvestments();
            });
        }
      }
    },

    validate(value) {
      this.toggle_disabled = this.item.status === "RUNNING" ? false : value;
    },

    colorResult(amount) {
      if (amount == 0) return "dark:text-gray-300 text-ontick-carbon-900";
      if (amount > 0) return "text-ontick-green-600";
      if (amount < 0) return "text-ontick-red-600";
    },

    textPosition(value) {
      let label;
      if (value == "BUY" || value == "Comprado") {
        label = "Comprado";
      } else if (value == "SELL" || value == "Vendido") {
        label = "Vendido";
      } else {
        label = "Zerado";
      }
      return label;
    },
  },
};
</script>
<style lang="scss" scoped>
.graph {
  @apply relative;
  &:before {
    content: " ";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.15;
    background-image: url("/img/pie-chart-compressed.png");
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 170px 170px;
  }
}
.arrows {
  @apply relative;
  &:before {
    content: " ";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.15;
    background-image: url("/img/arrows-compressed.png");
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 170px 170px;
  }
}
.dark {
  .graph {
    @apply relative;
    &:before {
      content: " ";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 1;
      background-image: url("/img/pie-chart-compressed.png");
      background-repeat: no-repeat;
      background-position: 90% 50%;
      background-size: 170px 170px;
    }
  }
  .arrows {
    @apply relative;
    &:before {
      content: " ";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 1;
      background-image: url("/img/arrows-compressed.png");
      background-repeat: no-repeat;
      background-position: 90% 60%;
      background-size: 170px 170px;
    }
  }
}
.graph-dark:before {
  opacity: 1;
}
.label_card {
  @apply text-xs text-gray-500 dark:text-gray-400;
}
.status_card {
  @apply text-center text-xs font-semibold;
}
.mask {
  &-enter,
  &-leave-to {
    @apply translate-y-4 transform opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
}
</style>
